import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-default-rank-popup',
  templateUrl: './default-rank-popup.component.html',
  styleUrls: ['./default-rank-popup.component.scss']
})
export class DefaultRankPopupComponent implements OnInit {

  parameters: any;
  isMobile = false;

  constructor(private dialogRef: MatDialogRef<DefaultRankPopupComponent>,
    private deviceService: DeviceDetectorService) {
    this.isMobile = this.deviceService.isMobile();
  }

  ngOnInit() {
  }


  resetDefaultRanking() {
    this.dialogRef.close(1);
  }

}
